import { IDeleteControleMateriaisUseCase } from "../../../presentation/useCases/delete/delete_controle_materiais_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteControleMateriaisUseCase
 */

export class DeleteControleMateriaisUseCase implements IDeleteControleMateriaisUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteControleMateriais(id: number): Promise<void> {
    await this.repository.deleteControleMateriais({ id });
  }
}
